import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  CoachingLiveArea,
  CoachingReportCriterion,
} from '@euler/model/coaching-practice';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';
import { Chip } from '../../../components/Chip';
import { kAnchorColors, kAnchorLabels } from '../../practiceCopy';
import { ReportHeading } from './ReportHeading';
import { ReportSection } from './ReportSection';

/** Each criterion, a card per area: how it went and the line that showed it. */
export const CriteriaSection = memo(
  ({
    criteria,
    areas,
  }: {
    criteria: CoachingReportCriterion[];
    areas: CoachingLiveArea[];
  }) => {
    const { rpx } = useResponsiveContext();
    const groups = areas
      .map(area => ({
        area,
        items: criteria.filter(x => x.area === area.area),
      }))
      .filter(x => x.items.length);
    return (
      <View style={{ gap: rpx(12) }}>
        <ReportHeading title="评分细节" />
        {groups.map(({ area, items }) => (
          <ReportSection key={area.area} style={{ padding: rpx(14) }}>
            <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
              {area.name}
            </Typography.Text>
            {items.map((x, i) => (
              <View
                key={x.criterionRef}
                style={{
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  gap: rpx(8),
                  ...(i
                    ? {
                        borderTopWidth: 1,
                        borderTopColor: aiColors.border,
                        paddingTop: rpx(10),
                      }
                    : null),
                }}
              >
                <View style={{ flex: 1, minWidth: 0, gap: rpx(4) }}>
                  <Typography.Text
                    size={rpx(14)}
                    bold
                    color={aiColors.foreground}
                  >
                    {x.name}
                  </Typography.Text>
                  {x.citedLine ? (
                    <Typography.Text
                      size={rpx(12)}
                      color={aiColors.mutedForeground}
                    >
                      {`你说：“${x.citedLine}”`}
                    </Typography.Text>
                  ) : null}
                </View>
                <View style={{ alignItems: 'flex-end', gap: rpx(4) }}>
                  <Chip
                    text={kAnchorLabels[x.anchor]}
                    color={kAnchorColors[x.anchor]}
                  />
                  {x.hinted ? (
                    <Chip text="带提示" color={aiColors.mutedForeground} />
                  ) : null}
                </View>
              </View>
            ))}
          </ReportSection>
        ))}
      </View>
    );
  },
);
